package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.outlined.FavoriteBorder
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.LibraryTvShow
import com.sweetlime.bingeamigo.presentation.features.library.TvLibraryViewModel
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun TvFavoriteButton(
    libraryTvShow: LibraryTvShow,
    modifier: Modifier = Modifier,
    viewModel: TvLibraryViewModel = koinViewModel()
) {
    val favorites by viewModel.favorites.collectAsState()
    val uiState by viewModel.uiState.collectAsState()
    val isFavorite = favorites.any { it.id == libraryTvShow.id }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(isFavorite) { isLoading = false }
    LaunchedEffect(uiState) {
        if (uiState is com.sweetlime.bingeamigo.state.LibraryUiState.Error) {
            isLoading = false
            viewModel.clearError()
        }
    }

    IconButton(
        onClick = {
            if (isLoading) return@IconButton
            isLoading = true
            if (isFavorite) viewModel.removeFromFavorites(libraryTvShow)
            else viewModel.addToFavorites(libraryTvShow)
        },
        modifier = modifier.background(Color.Black.copy(alpha = 0.5f), CircleShape)
    ) {
        if (isLoading) {
            CircularProgressIndicator(modifier = Modifier.size(18.dp), strokeWidth = 2.dp, color = Color.White)
        } else {
            Icon(
                imageVector = if (isFavorite) Icons.Filled.Favorite else Icons.Outlined.FavoriteBorder,
                contentDescription = if (isFavorite) "Remove from favorites" else "Add to favorites",
                tint = if (isFavorite) BrandColors.Favorite else Color.White
            )
        }
    }
}